<template>
<div>

	<slot name="top"></slot>

	<field v-if="!hideSuite"
		label="Suite #" 
		:col-class="localColClass" 
		v-model="localSuite" 
		:readonly="readonly" 
		:invalid="localInvalidSuite"
		v-on:change="change">
	</field>

	<!--
	<field 
		label="Address" 
		:col-class="localColClass" 
		v-model="localAddress" 
		:readonly="readonly" 
		:invalid="localInvalidAddress"
		v-on:change="change">
	</field>
	-->

	<autocomplete-address-field
		:value="localAddress"
		v-on:input="localAddress = $event; change()"
		v-on:address-selected="onAddressSelected"
		label="Address"
		:col-class="localColClass"
		:invalid="localInvalidAddress"
		:readonly="readonly"
		placeholder="Start typing an address">
	</autocomplete-address-field>

	<field 
		label="City" 
		:col-class="localColClass" 
		v-model="localCity" 
		:readonly="readonly" 
		:invalid="localInvalidCity"
		v-on:change="change">
	</field>

	<form-group label="Province/State" 
		:col-class="localColClass">

		<div class="d-flex">
			<field 
				:params="{type: showProvinceOptions ? 'province' : 'text'}" 
				v-model="localProvince" 
				:readonly="readonly" 
				:invalid="localInvalidProvince"
				v-on:input="change">
			</field>
			<button v-if="!readonly" class="btn btn-light btn-attached" type="button" v-on:click="toggleProvinceSelectionType">
				<i class="fa" :class="{
						'fa-pencil-alt' : showProvinceOptions,
						'fa-caret-down' : !showProvinceOptions
					}"></i>
			</button>
		</div>
	</form-group>

	<field label="Country" 
		:col-class="localColClass" 
		:params="{type:'text'}" 
		v-model="localCountry" 
		:readonly="readonly" 
		v-on:input="change">
	</field>

	<field :label="statesList.find(state => state.value == province) ? 'Zip Code' : 'Postal Code'"
		:col-class="localColClass" 
		v-model="localPostalCode" 
		:readonly="readonly" 
		:invalid="localInvalidPostalCode"
		v-on:input="change">
	</field>

	<button v-if="!readonly" class="btn btn-light btn-sm" type="button" v-on:click="clearAddress">Clear</button>

	<slot name="bottom"></slot>

</div>
</template>
<script type="text/javascript">
import Field from "./Field"
import FormGroup from "./FormGroup"
import AutocompleteAddressField from "./AutocompleteAddressField"

export default {
	name: "AddressManualSelector",
	components: {
		Field,
		FormGroup,
		AutocompleteAddressField
	},
	props: [
		"colClass",
		"suite",
		"address",
		"city",
		"province",
		"postalCode",
		"country",
		"readonly",
		"invalidList",
		"hideSuite"
	],
	data() {
		return {
			localSuite: this.suite ? this.suite : "",
			localAddress: this.address ? this.address : "",
			localCity: this.city ? this.city : "",
			localProvince: this.province ? this.province : "",
			localPostalCode: this.postalCode ? this.postalCode : "",
			localCountry: this.country ? this.country : "",
			showProvinceOptions: true
		}
	},
	watch: {
		suite() {
			if (this.suite) {
				this.localSuite = this.suite
				this.change()
			}
			else
				this.localSuite = ""
		},
		address() {
			if (this.address) {
				this.localAddress = this.address
				this.change()
			}
			else
				this.localAddress = ""
		},
		city() {
			if (this.city) {
				this.localCity = this.city
				this.change()
			}
			else
				this.localCity = ""
		},
		province() {
			if (this.province) {
				this.localProvince = this.province
				this.change()
			}
			else
				this.localProvince = ""
		},
		postalCode() {
			if (this.postalCode) {
				this.localPostalCode = this.postalCode
				this.change()
			}
			else
				this.localPostalCode = ""
		}
	},
	computed: {
		localColClass() {
			if (!this.colClass)
				return "col-md-4"
			else
				return this.colClass
		},
		localInvalidSuite() {
			if (this.invalidList && "suite" in this.invalidList)
				return this.invalidList.suite
			else
				return null		
		},
		localInvalidAddress() {
			if (this.invalidList && "address" in this.invalidList)
				return this.invalidList.address
			else
				return null		
		},
		localInvalidCity() {
			if (this.invalidList && "city" in this.invalidList)
				return this.invalidList.city
			else
				return null		
		},
		localInvalidProvince() {
			if (this.invalidList && "province" in this.invalidList)
				return this.invalidList.province
			else
				return null		
		},
		localInvalidPostalCode() {
			if (this.invalidList && "postal_code" in this.invalidList)
				return this.invalidList.postal_code
			else
				return null		
		}
	},
	methods: {
		init() {
			let vm = this
			this.localSuite = this.suite ? this.suite : ""
			this.localAddress = this.address ? this.address : ""
			this.localCity = this.city ? this.city : ""
			this.localProvince = this.province ? this.province : ""
			this.localPostalCode = this.postalCode ? this.postalCode : ""
			this.localCountry = this.country ? this.country : ""

			if (this.localProvince && !this.provincesList.find(pr => pr.value == this.localProvince) && !this.statesList.find(st => st.value == this.localProvince))
				this.showProvinceOptions = false
			else
				this.showProvinceOptions = true

			vm.setLocalCountry()
		},
		onAddressSelected(payload) {
			var vm = this
			if (!payload) return
			if (payload.address != null) vm.localAddress = payload.address
			if (payload.city != null) vm.localCity = payload.city
			if (payload.province != null) vm.localProvince = payload.province
			if (payload.country != null) vm.localCountry = payload.country
			if (payload.postal_code != null) vm.localPostalCode = payload.postal_code
			if (vm.localProvince && !vm.provincesList.find(function (pr) { return pr.value == vm.localProvince }) && !vm.statesList.find(function (st) { return st.value == vm.localProvince }))
				vm.showProvinceOptions = false
			else
				vm.showProvinceOptions = true
			vm.change()
		},
		setLocalCountry() {
			if (this.provincesList.find(pr => pr.value == this.localProvince))
				this.localCountry = "CA"
			else if (this.statesList.find(st => st.value == this.localProvince))
				this.localCountry = "USA"
		},
		toggleProvinceSelectionType() {
			if (this.showProvinceOptions) {
				this.showProvinceOptions = false
			}
			else
				this.showProvinceOptions = true
		},
		clearAddress() {
			this.localSuite = ""
			this.localAddress = ""
			this.localCity = ""
			this.localProvince = ""
			this.localPostalCode = ""
			this.localCountry = ""
			this.change()
		},
		change() {
			let vm = this
			this.$nextTick(() => {

				vm.setLocalCountry()

				let emitValue = {
					suite: vm.localSuite,
					address: vm.localAddress,
					city: vm.localCity,
					province: vm.localProvince,
					country: vm.localCountry,
					postal_code: vm.localPostalCode
				}

				vm.$emit("input",emitValue)
			})
		}
	},
	created() {
		this.init()
	},

}
</script>